export default "__VITE_ASSET__DDmcye8I__"